import Table from 'react-bootstrap/Table';

const Margin = ({ margin }) => {
    return (<Table className='table-bordered margin-table'>
        <tbody>
            <tr>
                <td>Span Margin</td>
                <td>{parseFloat(margin.SpanMargin).toFixed(2)}</td>
            </tr>
            <tr>
                <td>Exposure Margin</td>
                <td>{parseFloat(margin.ExposureMargin).toFixed(2)}</td>
            </tr>


            <tr>
                <td><b>Net Premium</b></td>
                <td><b>{parseFloat(margin.NetOptionsPremium).toFixed(2)}</b></td>
            </tr>
            <tr>
                <td><b>Total Amount Required</b></td>
                <td><b>{parseFloat(margin.TotalMargin).toFixed(2)}</b></td>
            </tr>
        </tbody>
    </Table>);
}

export default Margin;